'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tasks = require('./tasks.html');

var _tasks2 = _interopRequireDefault(_tasks);

var _taskAdd = require('./taskAdd.html');

var _taskAdd2 = _interopRequireDefault(_taskAdd);

var _taskDetail = require('./taskDetail.html');

var _taskDetail2 = _interopRequireDefault(_taskDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* @ngInject */
var TasksConfig = function TasksConfig($stateProvider) {
    $stateProvider.state('tasks', {
        url: '/tasks',
        template: _tasks2.default,
        controller: 'TasksController',
        controllerAs: 'tasks',
        params: { defaultTab: 'TASKS' }
    }).state('taskAdd', {
        url: '/tasks/add',
        template: _taskAdd2.default,
        controller: 'TaskAddController',
        controllerAs: 'taskAdd',
        params: { campaignId: null, contactId: null, investorId: null, customerInvestorId: null, isCustomerContact: false, tasksCount: null }
    }).state('taskEdit', {
        url: '/tasks/edit/:taskId',
        template: _taskAdd2.default,
        controller: 'TaskAddController',
        controllerAs: 'taskAdd',
        params: { callingPage: null, referenceId: null, tasksCount: null }
    }).state('taskDetail', {
        url: '/tasks/:taskId',
        template: _taskDetail2.default,
        controller: 'TaskDetailController',
        controllerAs: 'taskDetail',
        params: { callingPage: null, referenceId: null, tasksCount: null }
    });
};

exports.default = TasksConfig;


/** WEBPACK FOOTER **
 ** ./src/app/components/tasks/tasks.config.js
 **/